import React, { useState } from 'react';
import AdminBugReports from './AdminBugReports';
import AdminPokemonDefaults from './AdminPokemonDefaults';
import { useIsAdmin } from '../auth/useAdmin';
import { useAuth } from '../auth/AuthContext';
import './AdminDashboard.css';

const TABS = [
  { id: 'bugs', label: 'Bug reports' },
  { id: 'defaults', label: 'Pokémon defaults' },
];

function AdminDashboard() {
  const { user } = useAuth();
  const isAdmin = useIsAdmin();
  const [tab, setTab] = useState('bugs');

  if (!user) {
    return (
      <div className="admin-dash-gate">
        <h2>Sign in required</h2>
        <p>Admin tools are restricted. Sign in with the admin account to continue.</p>
      </div>
    );
  }
  if (!isAdmin) {
    return (
      <div className="admin-dash-gate error">
        <div className="admin-dash-gate-icon">⚠</div>
        <h2>Access denied</h2>
        <p>This page is restricted to the admin account. Signed in as <code>{user.email}</code>.</p>
      </div>
    );
  }

  return (
    <div className="admin-dash">
      <nav className="admin-dash-tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`admin-dash-tab${tab === t.id ? ' active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      <div className="admin-dash-body">
        {tab === 'bugs' && <AdminBugReports />}
        {tab === 'defaults' && <AdminPokemonDefaults />}
      </div>
    </div>
  );
}

export default AdminDashboard;
